export const ON_FIRMWARE_INFO_RECEIVED = 'ON_FIRMWARE_INFO_RECEIVED'
export const ON_BUILD_INFO_RECEIVED = 'ON_BUILD_INFO_RECEIVED'
export const ON_TERMINAL_INFO_RECEIVED = 'ON_TERMINAL_INFO_RECEIVED'

export const onFirmwareInfoReceived = (payload) => {
  return {
    type: ON_FIRMWARE_INFO_RECEIVED,
    payload,
  }
}

export const onBuildInfoReceived = (payload) => {
  return {
    type: ON_BUILD_INFO_RECEIVED,
    payload,
  }
}

export const onTerminalInfoReceived = (payload) => {
  return {
    type: ON_TERMINAL_INFO_RECEIVED,
    payload,
  }
}
